const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$',
  GBP: '£',
} as const;

export const formatCurrency = (currency: string) =>
  Object.keys(CURRENCY_SYMBOLS).includes(currency)
    ? CURRENCY_SYMBOLS[currency as keyof typeof CURRENCY_SYMBOLS]
    : currency;
